<template>
  <v-dialog v-model="dialog" persistent max-width="600px" min-width="360px">
    <div>
      <v-tabs
        v-model="activeTab"
        show-arrows
        background-color="primary"
        icons-and-text
        dark
        grow
      >
        <v-tabs-slider color="primary darken-4"></v-tabs-slider>

        <v-tab id="login-tab">
          <v-icon large>mdi-account</v-icon>
          <div class="caption py-1">Login</div>
        </v-tab>

        <v-tab id="register-tab">
          <v-icon large>mdi-account-outline</v-icon>
          <div class="caption py-1">Register</div>
        </v-tab>

        <v-tab-item>
          <div v-if="error !== false" class="error lighten-1">
            <p class="pa-5 text-center" v-html="error"></p>
          </div>
          <div v-if="message !== false" class="success">
            <p class="pa-5 text-center" v-html="message"></p>
          </div>
          <v-card class="px-4">
            <v-card-text>
              <v-form ref="loginForm" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      name="username"
                      v-model="username"
                      :rules="rules.username"
                      label="Username"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      block
                      v-model="password"
                      v-on:keyup.enter="submit"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="rules.password"
                      :type="showPassword ? 'text' : 'password'"
                      name="password"
                      label="Password"
                      hint="At least 8 characters"
                      counter
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" xsm="12"></v-col>
                  <v-spacer></v-spacer>
                  <v-col class="text-center" cols="12" sm="6">
                    <v-btn
                      x-large
                      block
                      color="primary"
                      :disabled="!valid || loading"
                      @click="submit"
                    >
                      <template v-if="loading">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="3"
                          color="white"
                        />
                      </template>

                      <template v-else>
                        Login
                      </template>
                    </v-btn>
                    <router-link
                      to="/register/password-reset"
                      class="d-block mt-2"
                    >
                      Forgot Password?
                    </router-link>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <Register :clearForm="clearForm" />
        </v-tab-item>
      </v-tabs>
    </div>
  </v-dialog>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapState, mapActions, mapMutations } from "vuex";
import Register from "@/components/auth/Register";
import rules from "@/utils/rules";

export default {
  name: "LoginComponent",
  components: { Register },
  data() {
    return {
      dialog: true,
      showPassword: false,
      tab: null,
      valid: false,
      clearForm: false,
      loading: false,
      rules: {
        password: [rules.required, rules.minLength(8)],
        username: [rules.required, rules.username]
      }
    };
  },
  computed: {
    ...mapState("auth", ["registration"]),
    ...mapFields("auth", [
      "username",
      "password",
      "is_register",
      "is_copy_to_register",
      "error",
      "activeTab",
      "message"
    ])
  },
  methods: {
    ...mapActions("auth", ["login"]),
    ...mapMutations("auth", ["clearRegistrationDetails", "clearLoginDetails"]),
    async submit() {
      if (!this.$refs.loginForm.validate()) return;

      this.is_register = false;
      this.is_copy_to_register = false;

      this.loading = true;

      try {
        await this.login();
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    activeTab() {
      this.clearRegistrationDetails();
      this.clearLoginDetails();
      this.$refs.loginForm.resetValidation();
      this.clearForm = !this.clearForm;
    }
  }
};
</script>
<style scoped>
::v-deep .v-text-field .v-label {
  top: -12px;
  font-size: 16px;
}

::v-deep .v-text-field .v-label--active {
  max-width: 133%;
  transform: none;
  pointer-events: auto;
  top: -12px;
}
</style>
